'use strict';

var URI = require('urijs');
require('urijs/src/URITemplate');

angular.module('amexReconciliationApp')
  .service('AccountingFieldAutocompleterFactory', function ($q, Bloodhound, MaskFormatterService) {
    var self = this;
    var MIN_SUFFICIENT_RESULTS = 100;

    self.create = function (params) {
      var url = URI.expand(
        '/api/v1/companies/{companyId}/sites/{siteNumber}/schema/{schemaPosition}/validValues',
        {
          companyId: params.companyId,
          siteNumber: params.siteNumber,
          schemaPosition: params.schema.position
        }
      );

      if (!schemaHasValidValues(params.schema)) {
        return {
          search: noValidValuesSearch
        };
      }

      var maskPattern = params.schema.maskPattern;
      var prepare;
      var transform;

      if (maskPattern) {
        transform = function (response) {
          var formattedValues = _.map(response, function (validValue) {
            if (validValue.value && MaskFormatterService.validateMask(validValue.value, params.schema)) {
              validValue.value = MaskFormatterService.formatForDisplay(validValue.value, params.schema);
              validValue.display = displayValue(validValue.value, validValue.description);
              validValue.validated = true;
            } else {
              validValue.validated = false;
            }

            return validValue;
          });

          _.remove(formattedValues, function (validValue) {
            return (validValue.value === undefined) || (!validValue.validated);
          });

          return formattedValues;
        };
        prepare = function (query, settings) {
          var q = MaskFormatterService.stripDelimiters(query.phrase, params.schema);
          if (q === undefined || q === '') { q = query.phrase; }
          settings.url = url.query({searchString: q, comboPositions: query.comboPositions, comboValues: query.comboValues}).toString();
          return settings;
        };
      } else {
        transform = function (response) {
          return _.map(response, function (validValue) {
            validValue.display = displayValue(validValue.value, validValue.description);
            return validValue;
          });
        };
        prepare = function (query, settings) {
          settings.url = url.query({searchString: query.phrase, comboPositions: query.comboPositions, comboValues: query.comboValues}).toString();
          return settings;
        };
      }

      var engine = new Bloodhound({
        identify: valueIdentify,
        queryTokenizer: queryTokenizerWithComboFields,
        datumTokenizer: tokenizeValidValue,
        prefetch: {
          url: url.toString(),
          transform: transform
        },
        remote: {
          url: url.query({searchString: 'QUERY', comboPositions: 'start,end', comboValues: 'start,end'}).toString(),
          rateLimitWait: 50,
          transform: transform,
          prepare: prepare
        },
        sufficient: MIN_SUFFICIENT_RESULTS
      });


      return {
        search: function (queryObject) {
          var deferred = $q.defer();
          var results = [];

          var upperCaseNewValuePhrase = String(queryObject.phrase).toUpperCase();
          var upperCaseQueryObject = {
            phrase: upperCaseNewValuePhrase,
            comboPositions: queryObject.comboPositions,
            comboValues: queryObject.comboValues
          };

          engine.search(upperCaseQueryObject, function (suggestedValues) {
            results = _.uniqBy(results.concat(suggestedValues), valueIdentify);
            if (results.length >= MIN_SUFFICIENT_RESULTS) {
              deferred.resolve(limitResponse(results));
            }
          }, function (suggestedValues) {
            results = _.uniqBy(results.concat(suggestedValues), valueIdentify);
            deferred.resolve(limitResponse(results));
          });

          return deferred.promise;
        },
        clear: function() {
          engine.clear();
          engine.clearRemoteCache();
        }
      };
    };

    function displayValue(value, description) {
      var display = value;
      if (description) {
        display = display + ' (' + description + ')';
      }

      return _.truncate(display, {length: 64});
    }

    function valueIdentify(validValue) {
      return validValue.value;
    }

    function schemaHasValidValues(schema) {
      var validationIndicator = _.get(schema, 'validationIndicator');
      return _.includes(['Y', 'C'], validationIndicator);
    }

    function limitResponse(validValues) {
      return _.slice(validValues, 0, MIN_SUFFICIENT_RESULTS);
    }

    function noValidValuesSearch() {
      return $q.when([]);
    }
    
    function tokenizeValidValue(validValue) {
      var tokens = [];
      var i = 0;

      if (validValue.value) {
        for (i = 0; i < validValue.value.length; i++) {
          if (validValue.value.charAt(i).trim() !== '') {
            tokens.push(validValue.value.slice(i));
          }
        }
      }

      if (validValue.description) {
        for (i = 0; i < validValue.description.length; i++) {
          if (validValue.description.charAt(i).trim() !== '') {
            tokens.push(validValue.description.slice(i));
          }
        }
      }

      return _.uniq(tokens);
    }

    function queryTokenizerWithComboFields(queryObject) {
      return Bloodhound.tokenizers.whitespace(queryObject.phrase);
    }
    
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/AccountingFieldAutocompleterFactory.js
// module id = 567
// module chunks = 0